import { Component, OnInit } from '@angular/core';
import { environment } from '@frontend/unhideschool/env';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';


const defaultSwiperConfigBreakpointProps = {
  spaceBetween: 20,
  slidesOffsetBefore: 65,
  slidesOffsetAfter: 65
};

@Component({
  selector: 'unh-depoimentos-container',
  templateUrl: './depoimentos-container.component.html',
  styleUrls: ['./depoimentos-container.component.scss'],
})
export class DepoimentosContainerComponent {
  swiperConfigsDepoimentos: SwiperConfigInterface = {
    ...defaultSwiperConfigBreakpointProps,
    slidesPerView: 4.6,
    loop: false,
    mousewheel: false,
    breakpoints: {
      480: {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      },
      768: {
        ...defaultSwiperConfigBreakpointProps,
        slidesPerView: 1.6,
      },
      992: {
        ...defaultSwiperConfigBreakpointProps,
        slidesPerView: 2.6,
      },
      1200: {
        ...defaultSwiperConfigBreakpointProps,
        slidesPerView: 3.6,
      },
      1536: {
        ...defaultSwiperConfigBreakpointProps,
        slidesPerView: 3.6,
      },
    }
  };

  depoimentos = [
    {
      avatar: environment.cdnUrl + '/testimonial-avatar/marcelo-matos.jpg',
      name: 'Marcelo Matos',
      specialty: 'Art Director',
      rating: 5,
      content:
        'Aqui você encontra os melhores profissionais da área, ensinando as melhores técnicas de retoque.',
    },
    {
      avatar: environment.cdnUrl + '/testimonial-avatar/lucas-olvra.jpg',
      name: 'Lucas Olvra',
      specialty: 'Digital Artist',
      rating: 5,
      // tslint:disable-next-line: max-line-length
      content: 'O melhor lugar para estudar. Aqui, encontrei o que eu precisava para aprimorar minhas habilidades. É uma plataforma absurdamente boa por um preço cada vez mais acessível.',
    },
    {
      avatar:
        environment.cdnUrl + '/testimonial-avatar/francisco-jonathan-de-ima-joaquim.png',
      name: 'Francisco Jonathan de Lima Joaquim',
      specialty: 'Art Director',
      rating: 4,
      // tslint:disable-next-line: max-line-length
      content: 'A metodologia dos professores é excelente, especialmente dos materiais quando começaram a ser em português, cresci muito o nível do meu trabalho tanto na escola como na mentoria do Milton […]',
    },
    {
      avatar: environment.cdnUrl + '/testimonial-avatar/denis-paganini.png',
      name: 'Denis Paganini',
      specialty: 'Art Director',
      rating: 5,
      content:
        '[...] amazing classes, outstanding teachers and impeccable teaching. I have no regrets about subscribing to.',
    },
    {
      avatar:
        environment.cdnUrl + '/testimonial-avatar/fabiano-itaque-gomes-da-silva.png',
      name: 'Fabiano Itaquê Gomes da Silva',
      specialty: 'Designer',
      rating: 5,
      // tslint:disable-next-line: max-line-length
      content: 'Sou novo assinante mas dos dois cursos que participei das aulas, achei um bem direto ao ponto e super explicativo por esse motivo[...]',
    },
    {
      avatar:
        environment.cdnUrl + '/testimonial-avatar/joao-paulo-maltarolo-crestani.png',
      name: 'Joao Paulo Maltarolo Crestani',
      specialty: '3D Artist',
      rating: 5,
      // tslint:disable-next-line: max-line-length
      content: 'I really like the content and the instructors, they are all high skilled people! My only complain is about the website, sometimes the videos won’t buffer. But nothing too serious! I’ve been learning a lot since I started!!.',
    },
    {
      avatar: environment.cdnUrl + '/testimonial-avatar/nelson-schmidt.png',
      name: 'Nelson Schmidt',
      specialty: 'Artist',
      rating: 5,
      // tslint:disable-next-line: max-line-length
      content: 'I truly admire what Unhide is doing for the community. I’m having the chance to upgrade my 3D, and photoshop skills in a way that I was never presented before. ',
    },
    {
      avatar: environment.cdnUrl + '/testimonial-avatar/leonardo-leme.png',
      name: 'Leonardo Leme',
      specialty: 'Digital Artist',
      rating: 5,
      content: 'My career is divided as before and after UNHIDE.',
    },
  ];
}
